<!-- 我的分享更多操作 -->
<template>
  <div>
    <!-- 有效分享操作菜单 -->
    <van-action-sheet :actions="validMoreList" v-model="showValid" cancelText="取消" class="uActionSheetStyle" @close="close" @select="selectValid" />
    <!-- 无效分享操作菜单 -->
    <van-action-sheet :actions="invalidMoreList" v-model="showInvalid" cancelText="取消" class="uActionSheetStyle" @close="close" @select="selectInvalid" />
    <!-- 文件操作菜单 -->
    <van-action-sheet :actions="fileMoreList" v-model="showFile" cancelText="取消" class="uActionSheetStyle" @close="close" @select="selectFile" />

    <!-- 属性弹框 -->
    <van-popup v-model="attributeShow" position="bottom">
      <template v-if="!Pitem.folderId">
        <div class="attributeContent">
          <div class="attributeItem">
            <span>分享人：</span>
            <span class="attributeItemData">{{ Pitem.operUserName }}</span>
          </div>
          <div class="attributeItem">
            <span>分享时间：</span>
            <span class="attributeItemData">{{ Pitem.operDate }}</span>
          </div>
          <div class="attributeItem">
            <span>失效时间：</span>
            <span class="attributeItemData">{{ Pitem.endDate }}</span>
          </div>
          <div class="attributeItem">
            <span>允许下载：</span>
            <span class="attributeItemData">{{ Pitem.isDownload ? "是" : "否" }}</span>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="attributeContent">
          <div class="attributeItem">
            <span>分享人：</span>
            <span class="attributeItemData">{{ Pitem.operUserName }}</span>
          </div>
          <div class="attributeItem">
            <span>分享时间：</span>
            <span class="attributeItemData">{{ Pitem.operDate }}</span>
          </div>
          <div class="attributeItem">
            <span>文件大小：</span>
            <span class="attributeItemData">{{ Pitem.isFile ? "--" : Pitem.fileSize }}</span>
          </div>
        </div>
      </template>
      <div class="attributeClose" @click="attributeShow = false">取消</div>
    </van-popup>
    <!-- 分享弹框 -->
    <van-popup v-model="shareShow" position="bottom" round @close="shareShow = false">
      <div class="shareStyle">
        <div class="linkText">{{ "链接：" + Pitem.fileUrl }}</div>
        <span class="linkBtn" @click="copyUrl(Pitem.fileUrl)">复制链接</span>
      </div>
    </van-popup>
    <!-- 取消分享弹框 -->
    <van-popup v-model="showCancel" round @close="showCancel = false">
      <div class="modalStyle">
        <div class="text">是否确定取消分享？</div>
        <div class="buttonSlider">
          <van-button text="取消" type="info" round plain @click="showCancel = false" />
          <van-button text="确认" type="info" round @click="cancelShare" />
        </div>
      </div>
    </van-popup>
    <!-- 删除分享弹框 -->
    <van-popup v-model="showDelete" round @close="showDelete = false">
      <div class="modalStyle">
        <div class="text">是否确定删除分享？</div>
        <div class="buttonSlider">
          <van-button text="取消" type="info" round plain @click="showDelete = false" />
          <van-button text="确认" type="info" round @click="deleteShare" />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Notify } from "vant";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import { downloadFile, downloadUrltoken, downloadFileShowPrompt } from "@/CommonDP/utils";
import docService from "@/CommonDP/service/doc-service";
import requestFile from "@/CommonDP/service/webShare-service";

export default {
  props: ["rootPrjId"],
  data() {
    return {
      // 有效链接操作菜单
      validMoreList: [],
      validPriviList: [
        { name: "查看链接", Privi: "" },
        { name: "取消分享", Privi: "" },
        { name: "属性", Privi: "" }
      ],
      // 无效链接操作菜单
      invalidMoreList: [],
      invalidPriviList: [
        { name: "查看链接", Privi: "" },
        { name: "删除", Privi: "" },
        { name: "属性", Privi: "" }
      ],
      // 文件操作菜单
      fileMoreList: [],
      filePriviList: [
        // { name: "下载", Privi: this.$allPerms.MYDOC_DOWN },
        { name: "属性", Privi: "" }
      ],
      showValid: false,
      showInvalid: false,
      showFile: false,
      Pitem: {}, // 当前操作的文档

      attributeShow: false, // 属性弹框
      shareShow: false, // 分享弹框
      showCancel: false, // 取消分享弹框
      showDelete: false // 删除分享弹框
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId, // 当前企业Id
      userInfo: (state) => state.user.userInfo
    })
  },
  onLoad() {},
  mounted() {},
  methods: {
    // 设置有效分享权限
    setValidPrivi(items) {
      this.Pitem = items || {};
      this.validMoreList = this.validPriviList.filter((item) => (item.Privi ? checkPermission(item.Privi) : true));
      this.showValid = true;
    },
    // 设置无效分享权限
    setInvalidPrivi(items) {
      this.Pitem = items || {};
      this.invalidMoreList = this.invalidPriviList.filter((item) => (item.Privi ? checkPermission(item.Privi) : true));
      this.showInvalid = true;
    },
    // 设置文件权限
    setFilePrivi(items) {
      this.Pitem = items || {};
      this.fileMoreList = this.filePriviList.filter((item) => (item.Privi ? checkPermission(item.Privi) : true));
      this.showFile = true;
    },
    // 关闭事件
    close() {
      this.showValid = false;
      this.showInvalid = false;
      this.showFile = false;
    },

    // 有效分享菜单事件
    selectValid(val) {
      if (val.name == "查看链接") this.shareShow = true;
      if (val.name == "取消分享") this.showCancel = true;
      if (val.name == "属性") this.queryAttribute();
    },
    // 无效分享菜单事件
    selectInvalid(val) {
      if (val.name == "查看链接") this.shareShow = true;
      if (val.name == "删除") this.showDelete = true;
      if (val.name == "属性") this.queryAttribute();
    },
    // 文件菜单事件
    selectFile(val) {
      if (val.name == "下载") this.downloadDoc(this.Pitem);
      if (val.name == "属性") this.queryAttribute();
    },

    // 属性
    queryAttribute() {
      this.close();
      this.attributeShow = true;
    },
    //复制链接
    copyUrl(url) {
      if (url) {
        this.$copyText(url).then(() => {
          Notify({ type: "success", message: "链接复制成功！!" });
        });
      }
    },
    // 取消分享
    async cancelShare() {
      const params = [this.Pitem.id];
      await requestFile.cancelShare(params);
      Notify({ type: "success", message: "取消成功!" });
      this.close();
      this.showCancel = false;
      this.$emit("toRefresh");
    },
    // 删除分享
    async deleteShare() {
      const params = [this.Pitem.id];
      await requestFile.personalDocDeleteShare(params);
      Notify({ type: "success", message: "删除成功!" });
      this.close();
      this.showDelete = false;
      this.$emit("toRefresh");
    },

    // 下载文件
    async downloadDoc(row) {
      const prjId = this.rootPrjId || "";
      const { userId } = this.userInfo || {};
      if (!row.isFile) {
        const fileId = row.folderId;
        const version = row.fileVersion;
        const downzipurl = downloadUrltoken(prjId, fileId, version);
        downloadFile(downzipurl);
      } else {
        const params = {
          folderId: row.folderId,
          rootDirectory: row.folderName,
          prjId: prjId,
          enterpriseId: this.enterpriseId,
          userId: userId
        };
        docService.downloadfolder(params).then((response) => {
          const fileName = row.folderName + ".zip";
          downloadFileShowPrompt(fileName, response);
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .uActionSheetStyle {
  .van-action-sheet__content {
    max-height: 50vh;
  }
  .van-action-sheet__item {
    border-bottom: 1px solid #e5e8f1 !important;
    .van-action-sheet__name {
      font-size: 16px;
      color: var(--key-color);
    }
  }

  .van-action-sheet__cancel {
    font-size: 16px;
    color: #007af5;
  }

  .van-action-sheet__gap {
    height: 1px !important;
    background-color: #e5e8f1 !important;
  }
}

.attributeContent {
  max-height: 240px;
  padding: 20px;

  .attributeItem {
    white-space: nowrap;
    overflow: overlay !important;
    overflow: auto;
    span {
      font-size: 16px;
      line-height: 40px;
    }
    .attributeItemData {
      color: var(--key-color);
    }
  }
}

.attributeClose {
  border-top: 1px solid #e5e8f1 !important;
  font-size: 16px !important;
  color: #007af5 !important;
  line-height: 50px;
  text-align: center;
}

.shareStyle {
  width: 100vw;
  padding: 30px 5vw 40px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .van-button {
    width: 120px;
    margin-top: 20px;
  }

  .linkText {
    width: 100%;
    margin-top: 20px;
    font-size: 14px;
    color: var(--key-color);
    word-break: break-all;
  }

  .linkBtn {
    margin-top: 20px !important;
    font-size: 14px;
    color: #007af5;
    cursor: pointer;
  }
}

.modalStyle {
  width: 90vw;
  padding: 3vh 4vw;

  .text {
    padding: 3vh 5vw;
    font-size: 16px;
    white-space: pre-wrap;
    text-align: center;
  }

  .buttonSlider {
    width: 100%;
    padding: 2vh 0;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .van-button {
      width: 40%;
    }
  }
}
</style>
